import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-top-three-box',
  templateUrl: './top-three-box.component.html',
  styleUrls: ['./top-three-box.component.css']
})
export class TopThreeBoxComponent implements OnInit {
  @Input() Title1: string;
  @Input() Title2: string;
  @Input() Title3: string;

  @Input() Count1: number;
  @Input() Count2: number;
  @Input() Count3: number;

  @Input() Flag1: number;
  @Input() Flag2: number;
  @Input() Flag3: number;

  @Output() filterEvent = new EventEmitter();

  constructor() {}

  ngOnInit() { }

  filterListing(value) {
    this.filterEvent.emit(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/top-three-box/top-three-box.component.ts